import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface Tutorial {
  _id: string;
  title: { en: string; am: string };
  description: { en: string; am: string };
  courseId: string;
  duration?: number;
  videoUrl?: string;
  slides?: Array<{
    _id: string;
    id?: string;
    title: { en: string; am: string };
    content: { en: string; am: string };
    imageUrl?: string;
  }>;
  quizzes?: Array<any>; // You can define a Quiz type for stricter typing
  thumbnail?: string;
  isActive?: boolean;
  level?: string;
  // Add other fields as needed
}

export const useTutorials = () => {
  return useQuery<Tutorial[]>({
    queryKey: ["tutorials"],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/api/v1/tutorials");
      return data?.data?.documents ?? [];
    },
  });
};

export const useTutorial = (tutorialId: string) => {
  return useQuery<Tutorial, unknown>({
    queryKey: ["tutorial", tutorialId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/api/v1/tutorials/${tutorialId}`
      );
      console.log(data.data);
      return data?.data?.document;
    },
    enabled: !!tutorialId,
  });
};
